/**
 * Copyright © WarmHeart Intelligence Technology Group (Jiangsu) Co.,Ltd Company, Limited.
 * All Rights Reserved
 */
import url from "./conf";
import {post, tokenPost} from "./ajax";

const bom = {
  /**
   *  AJAX-搜索产成品列表
   *  @param keys
   *  @param page
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listProduceMaterial(keys,page, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_PRODUCE_MATERIAL,
      {
        keys: keys,
        pageIndex: page.pagination,
        pageSize: page.size,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-搜索产成品的配方列表
   * @param materialId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listBom(materialId, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_BOM,
      {
        materialId: materialId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-搜索配方原材料列表
   * @param bomId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listBomItems(bomId, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_BOM_ITEMS,
      {
        bomId: bomId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },

  /**
   *  AJAX-添加配方
   *  @param materialId
   *  @param bomName
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  addBom(materialId, bomName, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_BOM,
      {
        materialId: materialId,
        bomName: bomName,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-添加配方原材料
   * @param bomId
   * @param materialId
   * @param counts
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  addBomDetail(bomId,materialId,counts, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_BOM_DETAIL,
      {
        bomId: bomId,
        materialId: materialId,
        counts: counts,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-删除配方
   * @param bomId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  removeBom(bomId, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.REMOVE_BOM,
      {
        bomId: bomId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-删除原材料
   *  @param itemId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  removeBomDetail(itemId, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.REMOVE_BOM_DETAIL,
      {
        itemId: itemId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-采用为默认配方
   * @param bomId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  setDefaultBom(bomId, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.SET_DEFAULT_BOM,
      {
        bomId: bomId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },

}

export default bom;



// WEBPACK FOOTER //
// ./src/assets/ajax/ajax-bom.js